import { render, staticRenderFns } from "./aztec1000.vue?vue&type=template&id=3c2cef7b&scoped=true"
import script from "./aztec1000.vue?vue&type=script&lang=js"
export * from "./aztec1000.vue?vue&type=script&lang=js"
import style0 from "./aztec1000.vue?vue&type=style&index=0&id=3c2cef7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2cef7b",
  null
  
)

export default component.exports